export default __webpack_public_path__ + "static/media/noun_Water_2353460.f1c24c06.png";